var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('add-dispatch-car-real',{attrs:{"dispatchId":_vm.dispatchId,"isSee":_vm.isSee == 1,"type":_vm.type,"op":_vm.op},on:{"reset":_vm.reset}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }